/**
 * PAPPO — ProtectedRoute
 * Encapsula rotas que requerem autenticação.
 * Redireciona para /login se o utilizador não estiver autenticado.
 */

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Loading } from '../common/Loading';

interface ProtectedRouteProps {
  /** Roles permitidas (vazio = todas) */
  allowedRoles?: Array<'child' | 'parent' | 'admin'>;
  /** Nível de conta mínimo (CONTRATOS §3). Ainda sem uso obrigatório. */
  minLevel?: number;
}

export function ProtectedRoute({ allowedRoles, minLevel }: ProtectedRouteProps) {
  const { user, isLoading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <Loading fullscreen text="Carregando..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/chat" replace />;
  }

  if (minLevel !== undefined && user && (user.account_level ?? 0) < minLevel) {
    return <Navigate to="/chat" replace />;
  }

  return <Outlet />;
}
